const routes = [
  {
    path: '/',
    name: 'Сводка',
    component: () => import('../pages/Home.vue')
  },
  {
    path: '/timeline',
    name: 'Timeline',
    component: () => import(/* webpackChunkName: "timeline" */ '../pages/Timeline.vue')
  },
  {
    path: '/plan',
    name: 'Plan',
    component: () => import(/* webpackChunkName: "plan" */ '../pages/Plan.vue')
  },
  {
    path: '/mailings',
    name: 'Рассылки',
    component: () => import('../pages/Mailings.vue')
  },
  {
    path: '/mailings/:id(\\d+|new)',
    name: 'Рассылка',
    component: () => import('../pages/Mailing.vue')
  },
  {
    path: '/activities',
    name: 'Активности',
    component: () => import(/* webpackChunkName: "activities" */ '../pages/Activities.vue')
  },
  {
    path: '/activities/:id(\\d+)',
    name: 'Активность',
    component: () => import('../pages/Activity.vue')
  },
  {
    path: '/shop-in-shop',
    name: 'Shop in shop',
    component: () => import('../pages/Shop-in-shop.vue')
  },
  {
    path: '/finances',
    name: 'Финансы',
    component: () => import('../pages/Finances.vue')
  },
  {
    path: '/contacts',
    name: 'Контакты',
    component: () => import('../pages/Contacts.vue')
  },
  {
    path: '/companies/page=:page(\\d+)',
    name: 'Компании',
    component: () => import('../pages/Companies.vue')
  },
  {
    path: '/companies',
    name: 'Компании',
    component: () => import('../pages/Companies.vue')
  },
  {
    path: '/companies/:id(\\d+|new)',
    name: 'Компания',
    component: () => import('../pages/Company.vue')
  },
  {
    path: '/spots',
    name: 'Инструменты',
    component: () => import('../pages/Spots.vue')
  },
  {
    path: '/prices/:product?',
    name: 'Прайс-лист',
    component: () => import('../pages/Prices.vue')
  },
  {
    path: '/users',
    name: 'Пользователи',
    component: () => import('../pages/Users.vue')
  },
  {
    path: '/support',
    name: 'Поддержка',
    component: () => import('../pages/Support.vue')
  },
  {
    path: '/account/profile',
    component: () => import('../pages/Profile.vue')
  }
]

export default routes
